import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],

})
export class HomePageComponent implements OnInit {

  constructor(private router:Router) {


  }
  services=[
    {title:"Managing student contributions",background:"#dadada",color:"#000"},
    {title:"Driver information management",background:"#ffffff",color:"#4839ff"},
    {title:"Set buses and manage information",background:"#8679ed",color:"#fff"},
    {title:"Add transmission lines",background:"#ffffff",color:"#703cd2"},
    {title:"Track bus traffic at the same time",background:"#ffffff",color:"#4a4ddc"},
    {title:"Control all accounts in the service",background:"#eeeaff",color:"#000"},
    {title:"Remote activation of services",background:"#ffffff",color:"#4040b5"},
    {title:"Crisis and emergency management",background:"#847aaf",color:"#fff"},
   ]
  ngOnInit() {
  }

  goToDiv(fragment) {
    let tree = this.router.parseUrl(this.router.url);
    if (tree.fragment == fragment) {
      let element = document.querySelector("#" + tree.fragment);
      if (element) {
        // @ts-ignore
        element.scrollIntoView(element);
      }
    }
    else {
      this.router.navigate(['/'], {fragment: fragment})
        .then( () => {
          let tree = this.router.parseUrl(this.router.url);
          let element = document.querySelector("#" + tree.fragment);
          if (element) {
            // @ts-ignore
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });
    }
  }
}
